export default __webpack_public_path__ + "static/media/2_Fotos_uebereinander.14f7c478.png";